import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class DpvAttribute extends Sensor {
  public dpvChart: any;
  private dpvSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.dpvChart = null;
    this.dpvSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;
      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.dpvSensor, position);
      this.dpvSensor[position].push([timestamp, element.dpv]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredDpv = this.dpvSensor.filter(series => series.length > 0);

    const positionNodeDpv = this.dpvSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.dpvChart = this.getConfigChar(
      'dpv',
      this.getChartSeriesNewNode('Sensor', filteredDpv, positionNodeDpv),
      this.getRanges('dpv'),
      this.getLimits('dpv')
    );
  }

  public hasDpvSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.dpvSensor.length &&
      this.dpvSensor[index].length > 0
    );
  }

  public getDpvSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.dpvSensor.length) {
      const sensorData = this.dpvSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Déficit de Presión de Vapor', value: 'dpv' }
    ];
  }
}
